import React from 'react';
import CompleteBubble from './CompleteBubble';
import ConfirmBubble from './ConfirmBubble';
import TerminationBubble from './TerminationBubble';
import WithdrawBubble from './WithdrawBubble';

import {
  CapaQuotationChatMessage,
  CapaQuotationChatMessageType,
  CapaQuotationChatMessageRfq,
  CapaQuotationChatRoomStatus
} from '@generated/graphql';

import useStyles from './useStyles';
import { useSelector } from '@store';

interface Props {
  message?: CapaQuotationChatMessage;
}

const CommonBubblePresenter: React.FC<Props> = ({ message }) => {
  const classes = useStyles();
  const status = useSelector((state) => state.chat.chatRoomStatus);

  const messageTypeName = message?.message?.__typename;
  const messageType = message?.message?.messageType ?? undefined;

  const isConfirmedByOther =
    status === CapaQuotationChatRoomStatus.ClosedConfirm;

  const isQuitBubble = [
    CapaQuotationChatMessageType.QuitChatroomClient,
    CapaQuotationChatMessageType.QuitChatroomPartner
  ];

  const isConfirmedBubble = [
    CapaQuotationChatMessageType.RfqConfirm,
    CapaQuotationChatMessageType.RfqExpirationConfirm
  ];

  if (messageTypeName === 'CAPAQuotationChatMessageRfq') {
    const chatMessage = message?.message as CapaQuotationChatMessageRfq;
    return (
      <div className={classes['Chat-Common-Bubble-root']}>
        {messageType === CapaQuotationChatMessageType.RfqComplete && (
          <CompleteBubble data={chatMessage} />
        )}

        {isConfirmedBubble.includes(
          messageType as CapaQuotationChatMessageType
        ) && (
          <ConfirmBubble
            data={chatMessage}
            isConfirmedByOther={isConfirmedByOther}
          />
        )}

        {isQuitBubble.includes(messageType as CapaQuotationChatMessageType) && (
          <TerminationBubble data={chatMessage} />
        )}

        {messageType === CapaQuotationChatMessageType.Withdraw && (
          <WithdrawBubble data={message} />
        )}
      </div>
    );
  }

  return null;
};

export default CommonBubblePresenter;
